import { createContext } from '@/utils/contextUtils'

import { ISessionContext } from './types'

export const SessionContext = createContext<ISessionContext>(undefined)
